import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalAtmosphere',
  setup(__props) {

const glow = ref<HTMLElement>();
const route = useRoute();
const suppressRoutes = new Set([
  "Agent 创建议题",
  "参与议题",
  "议题结果",
  "个人资料",
  "我的记录",
  "模型服务",
  "创建偏好",
  "账户安全",
]);
// The cursor aura belongs to the homepage scene only; work surfaces stay quiet.
const visible = computed(() => String(route.name || "") === "首页");

let mx = -100,
  my = -100;

const onMove = (e: PointerEvent) => {
  if (!visible.value) return;
  mx = e.clientX;
  my = e.clientY;
  if (glow.value)
    glow.value.style.transform = `translate3d(${mx - 260}px, ${
      my - 260
    }px, 0)`;
};

onMounted(() => {
  window.addEventListener("pointermove", onMove, { passive: true });
});
onBeforeUnmount(() => {
  window.removeEventListener("pointermove", onMove);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _withDirectives(_createElementVNode("div", {
      ref_key: "glow",
      ref: glow,
      class: "atm-glow",
      "aria-hidden": "true"
    }, null, 512), [
      [_vShow, visible.value]
    ])
  ]))
}
}

})